import {LegalDocumentDto} from '@multipass-user-service-dto';

export interface LegalDocument {
    readonly id: string;
    readonly type: string;
    readonly version: number;
    readonly effectiveFrom: string;
    readonly body: string;
}

export class LegalDocumentMapper {
    public mapLegalDocumentFromDto(dto: LegalDocumentDto): LegalDocument {
        return {
            id: dto.id,
            type: dto.type,
            version: dto.version,
            effectiveFrom: dto.effectiveFrom,
            body: dto.body,
        };
    }
}
